import { type ReactNode } from "react";

export function SubpageHero({
  eyebrow,
  title,
  highlight,
  subtitle,
  children,
}: {
  eyebrow?: string;
  title: ReactNode;
  highlight?: string;
  subtitle?: string;
  children?: ReactNode;
}) {
  return (
    <section className="relative border-b border-[var(--rule)] surface-hero">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-16 md:pt-24 pb-16 md:pb-24">
        {eyebrow && <div className="eyebrow mb-4 text-[var(--leaf)]">{eyebrow}</div>}
        <h1 className="font-display font-normal text-[2.2rem] sm:text-[3.2rem] md:text-[4.4rem] leading-[1.02] tracking-[-0.03em] max-w-4xl">
          <span className="text-[var(--ink)]">{title}</span>
          {highlight && (
            <>
              <br />
              <span className="text-[var(--leaf)]">{highlight}</span>
            </>
          )}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-lg md:text-xl text-[var(--ink)]/75 leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
